// Tiny DOM helpers.

// Every caller assumes the element exists (the cast hid that assumption). Throw with
// the selector on a miss so a renamed/removed id fails LOUDLY at the query site,
// instead of as an opaque null-deref crash somewhere downstream.
export const $ = <T extends HTMLElement = HTMLElement>(s: string): T => {
  const el = document.querySelector(s);
  if (!el) throw new Error(`missing element: ${s}`);
  return el as T;
};
